import React from 'react';
import SimpleAnalyticCard from '../cards/SimpleAnalyticCard';
import Grid from '@material-ui/core/Grid';
import { useSelector } from 'react-redux';

function SimpleAnalyticsUserPanel() {
  const analytics = useSelector(state => state.analytics);
  const totalProperties = analytics.byId.analytics['totalProperties'];
  const totalNewProperties = analytics.byId.analytics['totalNewProperties'];
  const totalNewContacts = analytics.byId.analytics['totalNewContacts'];
  const totalClosedOperations =
    analytics.byId.analytics['totalClosedOperations'];
  const totalRetireOperations =
    analytics.byId.analytics['totalRetireOperations'];
  const propertiesWithoutAuth =
    analytics.byId.analytics['propertiesWithoutAuth'];
  return (
    <Grid container spacing={2} style={{ margin: 0 }}>
      <SimpleAnalyticCard
        title={'Propiedades'}
        value={totalProperties?.metric}
        percentage={
          ((totalProperties?.metric - totalProperties?.prevMetric) * 100) /
          totalProperties?.prevMetric
        }
      />
      <SimpleAnalyticCard
        title={'Nuevas propiedades'}
        value={totalNewProperties?.metric}
        percentage={
          ((totalNewProperties?.metric - totalNewProperties?.prevMetric) *
            100) /
          totalNewProperties?.prevMetric
        }
      />
      <SimpleAnalyticCard
        title={'Consultas'}
        value={totalNewContacts?.metric}
        percentage={
          ((totalNewContacts?.metric - totalNewContacts?.prevMetric) * 100) /
          totalNewContacts?.prevMetric
        }
      />
      <SimpleAnalyticCard
        title={'Operaciones cerradas'}
        value={totalClosedOperations?.metric}
        percentage={
          ((totalClosedOperations?.metric - totalClosedOperations?.prevMetric) *
            100) /
          totalClosedOperations?.prevMetric
        }
      />
      <SimpleAnalyticCard
        title={'Operaciones canceladas'}
        value={totalRetireOperations?.metric}
        percentage={
          ((totalRetireOperations?.metric - totalRetireOperations?.prevMetric) *
            100) /
          totalRetireOperations?.prevMetric
        }
      />
      <SimpleAnalyticCard
        title={'Sin autorización'}
        value={propertiesWithoutAuth?.total}
      />
    </Grid>
  );
}

SimpleAnalyticsUserPanel.propTypes = {};

export default SimpleAnalyticsUserPanel;
